import React, { useEffect, useState } from "react";
import bitfinexLogo from "../../images/bitfinexLogo.png";
import bitmexLogo from "../../images/bitmexLogo.png";
import okxLogo from "../../images/okxLogo.png";
import binanceLogo from "../../images/binanceLogo.png";
import bybitLogo from "../../images/bybitLogo.png";
import coinbaseLogo from "../../images/coinbase.png";
import api from "../../api";
import { Loader } from "../global/loader";

const exchangeList = [
  {
    exchange: "binance",
    icon: binanceLogo,
  },
  {
    exchange: "okx",
    icon: okxLogo,
  },
];

export const LiveTrades = () => {
  const [selectedExchange, setSelectedExchange] = useState("binance");
  const [VolumeData, setVolumeData] = useState([]);
  const [loader, setLoader] = useState(true);

  const [selectedTf, setSelectedTf] = useState("24h");

  const getVolume = async () => {
    try {
      let payload = {
        exchange: selectedExchange,
      };
      setLoader(true);
      const resp = await api.getliveTrades(payload);
      // console.log(resp);
      if (resp?.data) {
        setVolumeData(resp?.data);
      }
      setLoader(false);
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getVolume();
  }, [selectedExchange]);

  // Collect available timeframes from first pair
  const timeframes =
    VolumeData?.[0]?.trades?.[0] &&
    Object.keys(VolumeData[0].trades[0]).filter((tf) => tf !== "1m");

  return (
    <div className="liquidityMain">
      <div className="selectCoin">
        <h5 className="me-2">Live Trades</h5>
        <div className="expand">
          <button
            className=" dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              src={selectedExchange == "binance" ? binanceLogo : okxLogo}
              alt="icon"
              width={"27px"}
              style={{ marginRight: 10 }}
            />
            {selectedExchange}
          </button>
          <ul className="dropdown-menu">
            <div className="coinSelector">
              {exchangeList.map((item, key) => (
                <div
                  className="coin"
                  onClick={() => setSelectedExchange(item.exchange)}
                  key={key}
                >
                  <img
                    loading="lazy"
                    width="20"
                    src={`${item?.icon}`}
                    srcSet={`${item?.icon}`}
                    alt=""
                  />
                  <div className="name">{item.exchange}</div>
                </div>
              ))}
            </div>
          </ul>
        </div>
      </div>
      <div className="descrip mb-2">
        Real-time trade updates with buy/sell quantities across multiple
        timeframes for comprehensive market analysis
      </div>
      <div className="timeframeRow">
        {timeframes &&
          timeframes.map((tf) => (
            <div
              className={selectedTf == tf ? "val active" : "val"}
              onClick={(e) => setSelectedTf(tf)}
            >
              {tf.toUpperCase()}
            </div>
          ))}
      </div>
      <div className="row">
        {VolumeData?.map((pair, index) => (
          <LiveDataCard key={index} pairData={pair} selectedTf={selectedTf} />
        ))}
      </div>
      {/* <LiveDataCard pairData={VolumeData || []} /> */}
      {loader && <Loader />}
    </div>
  );
};

const LiveDataCard = ({ pairData, selectedTf }) => {
  const trades = pairData?.trades?.[0] || {};
  const { buy_quantity = 0, sell_quantity = 0 } = trades[selectedTf] || {};
  const total = buy_quantity + sell_quantity;
  const buyPerc = total ? ((buy_quantity / total) * 100).toFixed(1) : 0;
  const sellPerc = total ? ((sell_quantity / total) * 100).toFixed(1) : 0;
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const formatNumber = (num) => {
    if (num === null || num === undefined) return "-";
    const absNum = Math.abs(num);
    if (absNum >= 1_000_000_000_000)
      return (num / 1_000_000_000_000).toFixed(1) + "T";
    if (absNum >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
    if (absNum >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
    if (absNum >= 1_000) return (num / 1_000).toFixed(1) + "K";
    return num.toFixed(2);
  };

  return (
    <div className="col-lg-6">
      <div className="liveDataCard">
        <div className="titleRow">
          <div className="pair">
            <div className="logo">
              <img
                src={`${baseUrl}/icon/${pairData?.pair
                  .split("-")[0]
                  .toLowerCase()}.svg`}
                alt="volume"
                className="w-100"
              />
            </div>
            {pairData?.pair || "N/A"}
          </div>
        </div>

        {!pairData?.trades ? (
          <div className="contentM">
            <div className="dataM">No trade data available</div>
          </div>
        ) : (
          <div className="contentM">
            <div className="dataM">
              <div className="data">
                <div className="timeframe">
                  {" "}
                  {selectedTf.toUpperCase()} Trades
                </div>
                <div className="bought">
                  <span>BOUGHT:</span> {formatNumber(buy_quantity)}
                </div>
                <div className="bought">
                  <span>SOLD:</span> {formatNumber(sell_quantity)}
                </div>
              </div>
              <div className="percRow">
                <div className="buy" style={{ width: `${buyPerc}%` }}></div>
                <div className="sell" style={{ width: `${sellPerc}%` }}></div>
              </div>
              <div className="percVal">
                <div>{buyPerc}%</div>
                <div className="color-red">{sellPerc}%</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
